export const language: any = {
    OkLogout: "Ja",
    CloseLogout: "Nein",
    OkLeave: "Austritt",
    CloseLeave: "Abbrechen",
    LabelPolicy: "Datenschutzrichtlinie",
    AppName: "Hey! Cooker",
    OnOffNotification: "Benachrichtigungen Ein/Aus",
    LabelReceiveNotificationSuggestion: "Rezeptvorschläge erhalten",
    LabelReceiveNotifyBreakfast: "Tägliche Frühstücksempfehlungen erhalten",
    LabelReceiveNotifyLunch: "Tägliche Mittagessenempfehlungen erhalten",
    LabelReceiveNotifyDinner: "Tägliche Abendessenempfehlungen erhalten",
    notification_history: "Benachrichtigungsverlauf",
    readAll: "Alle lesen",
    no_notification: "Keine Benachrichtigungshistorie",
    labelDisplayName: "Anzeigenamen eingeben",
    placeholderDisplayName: "Mindestens 4 Zeichen, maximal 20 Zeichen eingeben",
    changeDisplayName: "Anzeigenamen ändern",
};

